import { Box } from "@mui/material";
import FullAccessWarningIcon from "../../common/components/fullAccessWarningIcon/FullAccessWarningIcon";
import { UserRoleItem } from "../User.types";

// The role names used to render as one joined string. They are split into inline units so a full-access warning can
// sit beside the role that carries it instead of after the whole list.
export default function UserRoleNames(props: { roles: Array<UserRoleItem> | undefined }) {
    const roles = props.roles;

    if (!roles) {
        return null;
    }

    return (
        <Box component="span">
            {roles.map((role, index) => (
                <Box component="span" key={role.id} sx={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap" }}>
                    {role.name}
                    {role.hasFullAccess && <FullAccessWarningIcon />}
                    {index < roles.length - 1 && (
                        <Box component="span" sx={{ marginRight: 0.5 }}>
                            ,
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
}
